import React from 'react';

import {useExportDocumentActivity} from 'app/activity/api';
import {StyledFooterDIV} from 'app/general/structures/DocSidebarPagePanels';
import {DateRangeExportButton} from 'app/general/widgets/DateRangeExportButton';
import {gt} from 'app/utils/i18n';

import type {ContentType} from 'sweet-types';

type Props = {
  objectId: number | string;
  contentType: ContentType;
};
export default function ExportActivityButton({objectId, contentType}: Props) {
  return (
    <StyledFooterDIV>
      <DateRangeExportButton
        objectId={objectId}
        itemsType={gt('activities')}
        className="btn btn-secondary btn-sm btn-block"
        contentType={contentType}
        useExportHook={useExportDocumentActivity}
        successMessage={gt('Your activities have been exported.')}
      />
    </StyledFooterDIV>
  );
}
